module.exports = __webpack_public_path__ + "static/media/tutorial_intro.236855b4.mp4";